import { putGeneral } from '../index';

export const generateNewToken = body => {
  return putGeneral('/access-token', body);
};
